import {Component} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {IBaseCRUModalComponent} from '../../../../../sdk/src/components/ibase-cru-modal/ibase-cru-modal.component';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {SdkImportsModule} from '../../../../../sdk/src/sdk-imports';
import {FileEntryModelExtension} from '../../../api-extensions/models/file-entry.model-extension';
import {FileUtils} from '../../../utils/file.utils';
import {CpmCFileCreateUserDirApiSchema} from '../../../../../gen/cpm-c-api-ts/src/schemas/c-common/cpmc-file.api-schemas';
import {CpmCFileApiService} from '../../../../../gen/cpm-c-api-ts/src/services/c-common/cpmc-file.api-service';
import {Observable} from 'rxjs';

export class NewUserFileDirectoryModalConfig {
    constructor(public atResolvedPath: string) {}
}
export class NewUserFileDirectoryModalResult {
    constructor(public item?: FileEntryModelExtension) {}
}

/**
 * New/Edit User file directory modal
 */
@Component({
    selector: 'app-new-user-file-directory-modal',
    templateUrl: './new-user-file-directory-modal.component.html',
    imports: [ReactiveFormsModule, PrimeNgImportsModule, SdkImportsModule]
})
export class NewUserFileDirectoryModalComponent extends IBaseCRUModalComponent<
    FileEntryModelExtension,
    NewUserFileDirectoryModalComponent,
    NewUserFileDirectoryModalConfig,
    NewUserFileDirectoryModalResult
> {
    /**
     * Constructor
     */
    constructor() {
        super();

        this.configure('Directory', (model: FileEntryModelExtension) => model.name ?? '<Unknown directory>');
        this.config.width = '30rem';
        this.contentMinHeight = '4rem';
    }

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling is done in the parent)
     */
    protected async onReady(): Promise<void> {
        this.form = new FormGroup({
            name: new FormControl<string | null>(null, [
                Validators.required,
                Validators.pattern(FileUtils.FOLDER_NAME_REGEX)
            ])
        });
    }
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}

    // ===============================================================
    // ===============================================================

    /**
     * On submit
     */
    protected async onSubmit() {
        if (!this.canSubmit()) {
            return;
        }

        await this.onSubmitConfirmed();
    }
    /**
     * On submit (After potential validation)
     */
    private async onSubmitConfirmed() {
        if (!this.canSubmit()) {
            return;
        }

        const toSubmit: CpmCFileCreateUserDirApiSchema = {
            name: this.form.controls['name'].value,
            at_resolved_path: this.config.data!.extended!.atResolvedPath
        };

        await this.submitCU(
            null,
            CpmCFileApiService.postCreateUserDir,
            this.dummyPutCreateUserDir.bind(this),
            undefined,
            toSubmit,
            (resultCRUD: FileEntryModelExtension) => new NewUserFileDirectoryModalResult(resultCRUD)
        );
    }

    // ===============================================================
    // ===============================================================

    /**
     * Dummy proxy method
     */
    private dummyPutCreateUserDir(
        uuid: string,
        payload: CpmCFileCreateUserDirApiSchema
    ): Observable<FileEntryModelExtension> {
        return CpmCFileApiService.postCreateUserDir(payload);
    }
}
